import { Autocomplete, Button, TextField } from '@mui/material'
import React, { Fragment, useState } from 'react';
import { useCursoLoader } from './data';

export default function StepTwo({ setStep }) {

    const [curso, setCurso,] = useState({ nombre: "" });

    const { cursoList } = useCursoLoader();

    return (
        <Fragment>

            <div className='bg-white p-5 border-y-4 border-y-[var(--primary)] flex items-center justify-center flex-col'>

                <h1 className='text-[#004554] lg:text-[50px] font-medium text-center mb-6'>Que estudios estas</h1>

                <input type="text" className="border border-[#ccc] my-3 w-[400px] p-3 rounded-[5px]" placeholder="Grado en...." />

                <Autocomplete disablePortal freeSolo
                    value={curso} options={Array.isArray(cursoList) ? cursoList : []} getOptionLabel={(option) => option?.nombre}
                    onChange={(e, value) => setCurso(value)}
                    renderInput={(params) => (
                        <TextField {...params} label={'Curso...'} />
                    )}
                    className='w-[400px] '

                />

            </div>


            <Button variant="contained" onClick={_ => setStep(2)} className="!bg-[#ffc559] !text-[#004554] !capitalize !text-[20px] !px-12 !rounded-none !font-bold !w-fit z-[20] !absolute !right-5 !bottom-4">Siguiente</Button>

        </Fragment>
    )
}
